<template>
  <div id="new-person">
    <person-form :isDark="true" :subject="true" operation="create" @onCreate="onCreateSubject" @cancelled="onCancelSubject" :record="newSubject" v-if="!isCnpj"/>
    <company-form :isDark="true" :subject="true" operation="create" @onCreate="onCreateSubject" @cancelled="onCancelSubject" :record="newSubject" v-if="isCnpj"/>
  </div>
</template>

<script>
import AdminPersonForm from "../../AdminPersonForm"
import AdminCompanyForm from "../../AdminCompanyForm"
export default {
  name: 'NewSubjectView',
  components: {
    'person-form': AdminPersonForm,
    'company-form': AdminCompanyForm
  },
  props: {
    isCnpj: {
      type: Boolean
    },
  },
  data() {
    return {
      newSubject: {
        document_type: 'cpf',
        social_name: '',
        references: [],
        documents: []
      },
    }
  },
  methods: {
    onCreateSubject(record) {
      this.$emit('handle-event', {newSubject: record})
    },
    onCancelSubject() {
      this.newSubject = {
        document_type: 'cpf',
        social_name: '',
        references: [],
        documents: []
      }
      this.$emit('handle-event', {cancel: true})
    }
  }
}
</script>

<style>
#new-person {
  padding: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/NewTransaction/NewSubjectView.vue